import { types } from 'mobx-state-tree';

const Assessments = types.model('Assessments', {});

export default Assessments;
